import React from "react";

export default function OtherAttendeesTableHeader() {
  const columns = ["Name", "Type", "Phone", "Email", "Venue", ""];

  return (
    <div className="other-attendee-table-header">
      {columns.map((column, index) => (
        <p className="flex flex-align-center" key={index}>
          {column}
        </p>
      ))}
    </div>
  );
}
